import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    marginTop: 12,
  },
  reportTitle: {
    fontSize: 12,
    textAlign: "center",
  },
});

const InvoiceThankYouMsg = () => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>
      Note: This itemized invoice has been created as these are JLEC reportable
      expenditures. Please contact the Office of Government Affairs with any
      questions 614-247-8468.
    </Text>
  </View>
);

export default InvoiceThankYouMsg;
